(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-wishList"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
  /**
   * Loads product recommendations into the wishlist section.
   * Fetches products in chunks of 20 to avoid URL length limits.
   *
   * @param {Array} productIds - List of product handles/variants to fetch.
   */
  var loadProductRecommendationsIntoSection = function (productIds) {
    // Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector('.wish-list');
    if (productRecommendationsSection === null) {
      return;
    }

    if (productIds.length <= 0) {
      $('.noWishList').eq(0).addClass('noWishShow');
      productRecommendationsSection.innerHTML = ''; // Clear existing content
      return;
    }

    // Clear the existing list before appending new chunks
    // But we need to keep the structure valid. 
    // The structure inside .wish-list is a .production-list-filter container.
    // Let's reset it first.
    productRecommendationsSection.innerHTML = '<div class="production-list-filter product-wish-list product-list--per-row-4 product-list--image-shape-portrait-45"></div>';
    
    // Chunk the productIds into groups of 20
    const chunkSize = 20;
    for (let i = 0; i < productIds.length; i += chunkSize) {
        const chunk = productIds.slice(i, i + chunkSize);
        fetchChunk(chunk, productRecommendationsSection);
    }

    function fetchChunk(chunkIds, section) {
        var request = new XMLHttpRequest();
        let _url = chunkIds.toString();
        let url = `${section.dataset.url}&q=${_url}`;
        
        request.open('GET', url);
        request.onload = function () {
            if (request.status >= 200 && request.status < 300) {
                var container = document.createElement('div');
                container.innerHTML = request.response;
                
                // Extract new items from the response
                var newItems = container.querySelector('.production-list-filter').innerHTML;
                
                // Append to the existing list container
                var listContainer = section.querySelector('.production-list-filter');
                // Create a temporary div to parse HTML string
                var tempDiv = document.createElement('div');
                tempDiv.innerHTML = newItems;
                
                // Move children to listContainer
                while (tempDiv.firstChild) {
                    listContainer.appendChild(tempDiv.firstChild);
                }

                // Initialize features for new items
                theme.ProductBlockManager.loadImages(section);
                theme.initAnimateOnScroll();

                $('.product-wish-list .product-likeIcon').each(function (item, index) {
                    $(this).addClass('on');
                });
                theme.hideTbyb && theme.hideTbyb();
            }
        };
        request.send();
    }
  };
  // fetch when section reloads in editor
  document.addEventListener('shopify:section:load', function (event) {
    var productRecommendationsSection = document.querySelector('.wish-list');
    theme.ProductBlockManager.loadImages(productRecommendationsSection);
    theme.initAnimateOnScroll();
    if (
      document.querySelector(
        '[data-section-id="' + event.detail.sectionId + '"].wish-list',
      )
    ) {
      getWishList();
    }
  });

  // Fetching the recommendations on page load
  function getWishList() {
    const customer_id = __st.cid || 0;
    const visitor_id = window.visitorId || 0;
    $.ajax({
      type: 'get',
      url: addressUrl + `/collectListInfoByUserId/${customer_id}/${visitor_id}`,
      async: false,
      success: function (res) {
        let productIds = res.map(item => {
          let str = item.handle;
          if (item.variant_id) {
            str += `**${item.variant_id}`;
          }
          return str;
        });
        console.log(res, productIds);
        loadProductRecommendationsIntoSection(productIds);
      },
      error: function (err) {
        theme.errorPost(
          'productSearchingAutoSpell',
          err.status,
          `${customer_id}/${visitor_id}`,
        );
      },
    });
  }

  getWishList();
  });
  // $(document).on('click', '.product-likeIcon', function () {
  //   let deleteDom = $(this).parents('.product-block');
  //   let productId = $(this).data().id;
  //   const headerWishIcon = $('.header-wish-list-icon');
  //   const headerWishIconOn = $('.header-wish-list-icon-on');
  //   $(this).removeClass('on');
  //   // deleteDom.remove();
  //   if ($('.product-likeIcon').length <= 0) {
  //     $('.noWishList').eq(0).addClass('noWishShow');
  //     headerWishIconOn.hide();
  //     headerWishIcon.show();
  //   }
  // });

  // function deleteWish(productId, dom) {
  //   $.ajax({
  //     type: 'POST',
  //     url: addressUrl + '/removeCollect',
  //     data: JSON.stringify({
  //       user_id: __st.cid || 0,
  //       product_id: productId,
  //       visitor_id: window.visitorId || 0,
  //     }),
  //     headers: {
  //       'Content-type': 'application/json;charset=UTF-8',
  //     },
  //     success: function () {
  //       dom.remove();
  //     },
  //   });
  // }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
var loadProductRecommendationsIntoSection = function() {
// Look for an element with class 'product-recommendations'
var productRecommendationsSection = document.querySelector(".product-recommendations");
if (productRecommendationsSection === null) { return; }
// Create request and submit it using Ajax
var request = new XMLHttpRequest();
request.open("GET", productRecommendationsSection.dataset.url);
request.onload = function () {
if (request.status >= 200 && request.status < 300) {
var container = document.createElement("div");
container.innerHTML = request.response;
productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
theme.ProductBlockManager.loadImages(productRecommendationsSection);
theme.initAnimateOnScroll();
theme.hideTbyb && theme.hideTbyb()
$(".product-likeIcon").each(function(item,index){
if (theme._wishList && theme._wishList.includes($(this).data().id)) {
$(this).addClass("on")
}
})
slickInit()
}
};
request.send();
};
var slickInit = function () {
var productRecommendationsSectionContainer = document.querySelector(".container-product-recommendations");
console.log(productRecommendationsSectionContainer.dataset.size)
$('.product-list').slick({
slidesToShow: productRecommendationsSectionContainer.dataset.size < 4 ? productRecommendationsSectionContainer.dataset.size : 4,
slidesToScroll: 1,
infinite: false,
responsive: [
{
breakpoint: 480,
settings: {
infinite: false,
slidesToShow: 2.3,
slidesToScroll: 2,
arrows: false,
}
}
]
});
}
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function (event) {
var productRecommendationsSection = document.querySelector(".product-recommendations");
theme.ProductBlockManager.loadImages(productRecommendationsSection);
theme.initAnimateOnScroll();
if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
loadProductRecommendationsIntoSection();

}
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();
slickInit()
console.log(4)
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-second-recommendations"] && !Shopify.designMode) return;
  try {
    
  var slickInit = function () {
    if (typeof window.Swiper === 'undefined') return;
    new window.Swiper('.recommendSwiper', {
      slidesPerView: 2.1,
      spaceBetween: 10,
      breakpoints: {
        767: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  };
  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(() => {
      slickInit();
    }, 200);
  });

  } catch(e) { console.error(e); }
})();
})();
